export const LEGAL_VERSIONS = {
  privacyVersion: '1.0.0',
  termsVersion: '1.0.0',
  consentVersion: '1.0.0',
} as const;

export type LegalLocale = 'en' | 'ru';
export type LegalDocumentType = 'privacy' | 'terms' | 'personal_data_consent';

export interface LegalOperatorConfig {
  brandName: string;
  legalName: string;
  legalForm: string;
  country: string;
  taxId: string;
  contactEmail: string;
  supportTelegram: string;
  telegramUrl: string;
  address: string;
  privacyContact: string;
  effectiveDate: string;
}

export const REQUIRED_LEGAL_OPERATOR_FIELDS: ReadonlyArray<keyof LegalOperatorConfig> = [
  'brandName', 'legalName', 'legalForm', 'country', 'contactEmail', 'supportTelegram', 'telegramUrl', 'privacyContact', 'effectiveDate',
];

export function missingLegalOperatorFields(config: LegalOperatorConfig): Array<keyof LegalOperatorConfig> {
  return REQUIRED_LEGAL_OPERATOR_FIELDS.filter((field) => !config[field].trim());
}
